/*
Monotype Foundry Platform API
Version 1.0.0

Definition: UsersApplication

Properties:
  agreement: object (required)
  applicationId: string
  applicationStatus: string (required)
  createdAt: string
  designers: object (required)
  existingDesigners: array
  foundry: object (required)
  id: string
  message: object
  messageHistory: array
  updatedAt: string
  userId: string (required)
  predictionScore: string
*/

var UsersApplication = (function () {
  function validateUsersApplication (arg) {
    // Validate agreement
    if (!arg.agreement) {
      throw new Error('UsersApplication.agreement: Missing property')
    }
    if (arg.agreement && !(typeof arg.agreement === 'object')) {
      throw new Error('UsersApplication.agreement: Wrong type: Got \'' + (typeof arg.agreement) + '\', but expected: \'object\'')
    }
    // Validate applicationStatus
    if (!arg.applicationStatus) {
      throw new Error('UsersApplication.applicationStatus: Missing property')
    }
    if (arg.applicationStatus && !(typeof arg.applicationStatus === 'string')) {
      throw new Error('UsersApplication.applicationStatus: Wrong type: Got \'' + (typeof arg.applicationStatus) + '\', but expected: \'string\'')
    }
    // Validate designers
    if (!arg.designers) {
      throw new Error('UsersApplication.designers: Missing property')
    }
    if (arg.designers && !(typeof arg.designers === 'object')) {
      throw new Error('UsersApplication.designers: Wrong type: Got \'' + (typeof arg.designers) + '\', but expected: \'object\'')
    }
    // Validate existingDesigners
    if (arg.existingDesigners && !(Array.isArray(arg.existingDesigners))) {
      throw new Error('UsersApplication.existingDesigners: Wrong type: Got \'' + (typeof arg.existingDesigners) + '\', but expected: \'array\'')
    }
    // Validate foundry
    if (!arg.foundry) {
      throw new Error('UsersApplication.foundry: Missing property')
    }
    if (arg.foundry && !(typeof arg.foundry === 'object')) {
      throw new Error('UsersApplication.foundry: Wrong type: Got \'' + (typeof arg.foundry) + '\', but expected: \'object\'')
    }
    // Validate message
    if (arg.message && !(typeof arg.message === 'object')) {
      throw new Error('UsersApplication.message: Wrong type: Got \'' + (typeof arg.message) + '\', but expected: \'object\'')
    }
    // Validate userId
    if (!arg.userId) {
      throw new Error('UsersApplication.userId: Missing property')
    }
    if (arg.userId && !(typeof arg.userId === 'string')) {
      throw new Error('UsersApplication.userId: Wrong type: Got \'' + (typeof arg.userId) + '\', but expected: \'string\'')
    }
  }
  function buildUsersApplication (arg) {
    var UsersApplication = arg
    // Complete agreement
    // Expected Type: object
    UsersApplication.agreement = UsersApplication.agreement || {}
    // Complete agreement.address1
    // Expected Type: string
    UsersApplication.agreement.address1 = UsersApplication.agreement.address1 || ''
    // Complete agreement.address2
    // Expected Type: string
    UsersApplication.agreement.address2 = UsersApplication.agreement.address2 || ''
    // Complete agreement.city
    // Expected Type: string
    UsersApplication.agreement.city = UsersApplication.agreement.city || ''
    // Complete agreement.country
    // Expected Type: object
    UsersApplication.agreement.country = UsersApplication.agreement.country || {}
    // Complete agreement.documentUrl
    // Expected Type: string
    UsersApplication.agreement.documentUrl = UsersApplication.agreement.documentUrl || ''
    // Complete agreement.email
    // Expected Type: string
    UsersApplication.agreement.email = UsersApplication.agreement.email || ''
    // Complete agreement.emailConsent
    // Expected Type: string
    UsersApplication.agreement.emailConsent = UsersApplication.agreement.emailConsent || ''
    // Complete agreement.envelopeId
    // Expected Type: string
    UsersApplication.agreement.envelopeId = UsersApplication.agreement.envelopeId || ''
    // Complete agreement.firstName
    // Expected Type: string
    UsersApplication.agreement.firstName = UsersApplication.agreement.firstName || ''
    // Complete agreement.lastName
    // Expected Type: string
    UsersApplication.agreement.lastName = UsersApplication.agreement.lastName || ''
    // Complete agreement.phone
    // Expected Type: string
    UsersApplication.agreement.phone = UsersApplication.agreement.phone || ''
    // Complete agreement.state
    // Expected Type: object
    UsersApplication.agreement.state = UsersApplication.agreement.state || {}
    // Complete agreement.yourName
    // Expected Type: string
    UsersApplication.agreement.yourName = UsersApplication.agreement.yourName || ''
    // Complete agreement.yourTitle
    // Expected Type: string
    UsersApplication.agreement.yourTitle = UsersApplication.agreement.yourTitle || ''
    // Complete agreement.zipCode
    // Expected Type: string
    UsersApplication.agreement.zipCode = UsersApplication.agreement.zipCode || ''
    // Complete applicationStatus
    // Expected Type: string
    UsersApplication.applicationStatus = UsersApplication.applicationStatus || ''
    // Complete designers
    // Expected Type: object
    UsersApplication.designers = UsersApplication.designers || {}
    // Complete designers.designers
    // Expected Type: array
    UsersApplication.designers.designers = UsersApplication.designers.designers || []
    // Complete designers.exists
    // Expected Type: boolean
    UsersApplication.designers.exists = UsersApplication.designers.exists || false
    // Complete existingDesigners
    // Expected Type: array
    UsersApplication.existingDesigners = UsersApplication.existingDesigners || []
    // Complete foundry
    // Expected Type: object
    UsersApplication.foundry = UsersApplication.foundry || {}
    // Complete foundry.foundryDescription
    // Expected Type: string
    UsersApplication.foundry.foundryDescription = UsersApplication.foundry.foundryDescription || ''
    // Complete foundry.foundryName
    // Expected Type: string
    UsersApplication.foundry.foundryName = UsersApplication.foundry.foundryName || ''
    // Complete foundry.aiAgreementId
    // Expected Type: string
    UsersApplication.foundry.aiAgreementId = UsersApplication.foundry.aiAgreementId || ''
    // Complete message
    // Expected Type: object
    UsersApplication.message = UsersApplication.message || {}
    // Complete message.description
    // Expected Type: string
    UsersApplication.message.description = UsersApplication.message.description || ''
    // Complete message.sentBy
    // Expected Type: string
    UsersApplication.message.sentBy = UsersApplication.message.sentBy || ''
    // Complete userId
    // Expected Type: string
    UsersApplication.userId = UsersApplication.userId || ''
    return UsersApplication
  }
  return {
    validate: validateUsersApplication,
    build: buildUsersApplication
  }
})()

module.exports = UsersApplication
